<template>
    <div class="bg-white px-6 pb-32 pt-40 lg:px-8">
        <div class="mx-auto max-w-3xl text-base leading-7 text-gray-700">
            <p class="text-base font-semibold leading-7 text-red-600">{{ $t('legal') }}</p>
            <h1 class="mt-2 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">{{ $t('legal.title') }}</h1>
            <p class="mt-6 text-xl leading-8">{{ $t('legal.text-1') }}</p>
            <div class="mt-10 max-w-2xl">
                <h2 class="my-8 text-2xl font-bold tracking-tight text-gray-900">{{ $t('legal.subtitle.first') }}</h2>
                <p>{{ $t('legal.text-3') }}</p>
            </div>
            <div class="mt-10 max-w-2xl">
                <h2 class="my-8 text-2xl font-bold tracking-tight text-gray-900">{{ $t('legal.subtitle.second') }}</h2>
                <p>{{ $t('legal.text-4') }}</p>
                <p>{{ $t('legal.text-5') }}</p>
                <p>{{ $t('legal.text-6') }}</p>
                <p>{{ $t('legal.text-7') }}</p>
            </div>
            <div class="mt-10 max-w-2xl">
                <h2 class="my-8 text-2xl font-bold tracking-tight text-gray-900">{{ $t('legal.subtitle.third') }}</h2>
                <p>{{ $t('legal.text-8') }}<NuxtLink class="font-semibold text-red-600" href="tel:+377 97 97 51 03">+377 97 97 51 03</NuxtLink></p>
                <p>{{ $t('legal.text-9') }}<NuxtLink class="font-semibold text-red-600" href="mailto:info@mve.mc">info@mve.mc</NuxtLink></p>
                <div class="rounded-md bg-blue-50 p-4 mt-12">
                    <div class="flex">
                        <div class="flex-shrink-0">
                            <InformationCircleIcon class="h-5 w-5 text-blue-400" aria-hidden="true" />
                        </div>
                        <div class="ml-3 flex-1 md:flex md:justify-between">
                            <p class="text-sm text-blue-700">{{ $t('legal.text-10') }}</p>
                            <p class="mt-3 text-sm md:ml-6 md:mt-0">
                                <NuxtLink :href="localePath('/support')" class="whitespace-nowrap font-medium text-blue-700 hover:text-blue-600">
                                    {{ $t('legal.subtitle.third') }}
                                    <span aria-hidden="true"> &rarr;</span>
                                </NuxtLink>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="mt-10 max-w-2xl">
                    <h2 class="my-8 text-2xl font-bold tracking-tight text-gray-900">{{ $t('legal.subtitle.fourth') }}</h2>
                    <p>{{ $t('legal.text-11') }}</p>
                    <p class="mt-4">{{ $t('legal.text-12') }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { InformationCircleIcon } from '@heroicons/vue/20/solid'

const { t } = useI18n()
</script>
